import { CartLinesUpdateEvent } from '@shopify/events';
const COL = '/collections/scialli/products.json?limit=250';
const J = { 'Content-Type': 'application/json', Accept: 'application/json' };
const ensureJs = (u, f) => { const b = u || f; return b.endsWith('.js') ? b : b + '.js'; };
const ADD = ensureJs(window.Theme?.routes?.cart_add_url, '/cart/add.js');
const CHANGE = ensureJs(window.Theme?.routes?.cart_change_url, '/cart/change.js');
const esc = (s) => { const d = document.createElement('div'); d.textContent = s ?? ''; return d.innerHTML; };
const sized = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w + '&height=' + w + '&crop=center' : '');
const CSS = `
html body .sc-chip{display:block!important;visibility:visible!important;list-style:none;margin:6px 0 0;padding:0}
.sc-chg{display:inline-flex;align-items:center;gap:6px;margin:0;padding:5px 11px;border:1px solid #cfc7bc;border-radius:999px;background:#fff;color:#1d1a17;font:inherit;font-size:12px;font-weight:600;line-height:1.2;cursor:pointer;box-shadow:none;text-transform:none;letter-spacing:0}
.sc-chg:hover{border-color:#1d1a17}
.sc-chg svg{width:12px;height:12px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
.sc-pop{position:fixed;inset:0;z-index:100000;display:flex;align-items:flex-end;justify-content:center;width:100%;max-width:none;height:100%;max-height:none;margin:0;padding:0;border:0;background:rgb(29 26 23/.5);font-family:Inter,system-ui,-apple-system,'Segoe UI',sans-serif;color:#1d1a17}
.sc-pop::backdrop{background:transparent}
.sc-pop *{box-sizing:border-box}
.sc-pop__sheet{position:relative;width:100%;max-width:520px;max-height:88vh;overflow:auto;padding:14px 16px calc(18px + env(safe-area-inset-bottom));background:#fff;border-radius:18px 18px 0 0;box-shadow:0 -8px 40px rgb(0 0 0/.18)}
.sc-pop__x{position:absolute;top:10px;right:12px;display:grid;place-items:center;width:34px;height:34px;margin:0;padding:0;border:0;border-radius:50%;background:#f4efe9;color:#1d1a17;font-size:22px;line-height:1;cursor:pointer}
.sc-pop__h{margin:0;padding:0 40px 0 0;font-size:17px;font-weight:700;line-height:1.25}
.sc-pop__sub{margin:2px 40px 14px 0;font-size:13px;line-height:1.3;color:#7a7068}
.sc-pop__grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 10px}
.sc-col{display:flex;flex-direction:column;align-items:center;gap:6px;min-width:0;margin:0;padding:0;border:0;background:none;color:#1d1a17;font:inherit;cursor:pointer;text-transform:none;letter-spacing:0;box-shadow:none}
.sc-col__img{position:relative;display:block;width:100%;aspect-ratio:1/1;border-radius:12px;overflow:hidden;border:1px solid rgb(0 0 0/.15);background:#faf6f1}
.sc-col__img img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center 30%}
.sc-col.is-on .sc-col__img{box-shadow:0 0 0 2px #fff,0 0 0 4px #75000b}
.sc-col__n{display:block;max-width:100%;font-size:12.5px;line-height:1.2;text-align:center;overflow-wrap:anywhere}
.sc-col.is-on .sc-col__n{font-weight:700;color:#75000b}
.sc-col:disabled{cursor:not-allowed}
.sc-col:disabled .sc-col__img,.sc-col:disabled .sc-col__n{opacity:.4}
.sc-col:disabled .sc-col__img::after{content:"";position:absolute;inset:0;background:linear-gradient(to top right,transparent calc(50% - 1px),#1d1a17 calc(50% - 1px),#1d1a17 calc(50% + 1px),transparent calc(50% + 1px))}
.sc-pop__busy{display:none;position:absolute;inset:0;align-items:center;justify-content:center;flex-direction:column;gap:4px;padding:20px;background:rgb(255 255 255/.92);border-radius:inherit;font-size:15px;font-weight:600;text-align:center}
.sc-pop__busy.is-on{display:flex}
.sc-pop__busy.is-err{color:#8d1a14;cursor:pointer}
.sc-pop__busy span{font-size:12.5px;font-weight:400;color:#7a7068}
@media(min-width:750px){.sc-pop{align-items:center}.sc-pop__sheet{max-width:440px;padding:20px;border-radius:16px;box-shadow:0 24px 70px rgb(0 0 0/.28)}}
`;
const ensureStyle = () => {
  if (document.getElementById('sc-css')) return;
  const s = document.createElement('style'); s.id = 'sc-css'; s.textContent = CSS; document.head.appendChild(s);
};
let catP = null;
const catalog = () => {
  if (!catP) catP = fetch(COL).then((r) => (r.ok ? r.json() : Promise.reject(new Error('cat')))).then((j) => j.products || []).catch((e) => { catP = null; throw e; });
  return catP;
};
const getItems = async () => {
  try {
    const [cart, prods] = await Promise.all([fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()), catalog()]);
    const map = new Map(prods.map((p) => [String(p.id), p]));
    return (cart.items || []).filter((i) => map.has(String(i.product_id))).map((i) => ({ it: i, p: map.get(String(i.product_id)) }));
  } catch (e) { return []; }
};
const colorIdx = (p) => {
  const i = (p.options || []).findIndex((o) => String(o.name).trim().toLowerCase() === 'colore');
  return i < 0 ? 0 : i;
};
const imgOf = (p, v) => {
  if (v.featured_image?.src) return v.featured_image.src;
  const im = (p.images || []).find((x) => x.id === v.image_id);
  return (im || (p.images || [])[0] || {}).src || '';
};
class Pop {
  constructor(o) {
    this.o = o; this.busy = false;
    ensureStyle(); this.build(); this.fill();
  }
  build() {
    const { p, it } = this.o;
    const d = document.createElement('dialog');
    d.className = 'sc-pop';
    d.innerHTML = `<div class="sc-pop__sheet" role="document" aria-labelledby="sc-t">
<button type="button" class="sc-pop__x" aria-label="Chiudi">×</button>
<h3 class="sc-pop__h" id="sc-t">Cambia colore</h3>
<p class="sc-pop__sub">${esc(p.title.split(' - ')[0])} · scegli il colore che preferisci</p>
<div class="sc-pop__grid" data-g></div>
<div class="sc-pop__busy" data-b aria-live="polite"></div></div>`;
    document.body.appendChild(d);
    document.documentElement.style.overflow = 'hidden';
    this.d = d; this.g = d.querySelector('[data-g]'); this.b = d.querySelector('[data-b]');
    d.querySelector('.sc-pop__x').addEventListener('click', () => this.close());
    d.addEventListener('click', (e) => { if (e.target === d) this.close(); });
    d.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
    try { d.showModal(); } catch (e) { d.setAttribute('open', ''); }
  }
  close() {
    if (this.busy) return;
    document.documentElement.style.overflow = '';
    try { this.d.close(); } catch (e) { /* noop */ }
    this.d.remove(); Pop.active = null;
  }
  fill() {
    const { p, it } = this.o;
    const ci = colorIdx(p);
    const cur = (it.options_with_values || [])[ci]?.value;
    const seen = new Map();
    (p.variants || []).forEach((v) => {
      const c = v['option' + (ci + 1)];
      if (!seen.has(c)) seen.set(c, []);
      seen.get(c).push(v);
    });
    seen.forEach((vs, c) => {
      const ok = vs.find((v) => v.available);
      const v = ok || vs[0];
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sc-col' + (c === cur ? ' is-on' : '');
      b.disabled = !ok || c === cur && false;
      b.innerHTML = `<span class="sc-col__img"><img src="${esc(sized(imgOf(p, v), 240))}" alt="" loading="lazy"></span><span class="sc-col__n">${esc(c)}</span>`;
      b.addEventListener('click', () => (c === cur ? this.close() : this.pick(ok)));
      this.g.appendChild(b);
    });
  }
  show(html, err) { this.b.className = 'sc-pop__busy is-on' + (err ? ' is-err' : ''); this.b.innerHTML = html; }
  async pick(v) {
    if (this.busy) return;
    this.busy = true;
    const { it } = this.o;
    this.show('Aggiorno il carrello…<span>Lo sconto si applica da solo</span>');
    const props = it.properties && Object.keys(it.properties).length ? it.properties : undefined;
    const item = { id: v.id, quantity: 1 };
    if (props) item.properties = props;
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'standard-action', lines: [{ merchandiseId: v.id, quantity: 1 }], promise: deferred.promise }));
    let ok = false, removed = false;
    try {
      const rm = await fetch(CHANGE, { method: 'POST', headers: J, body: JSON.stringify({ id: it.key, quantity: Math.max(0, (it.quantity || 1) - 1) }) });
      if (!rm.ok) throw new Error('rm');
      removed = true;
      const res = await fetch(ADD, { method: 'POST', headers: J, body: JSON.stringify({ items: [item], sections: 'cart-drawer-section' }) });
      const json = await res.json();
      if (!res.ok || json.status) deferred.resolve({ detail: { source: 'scialli-cambia', didError: true } });
      else { ok = true; deferred.resolve({ detail: { sections: json.sections, items: json.items, itemCount: json.item_count, source: 'scialli-cambia', didError: false } }); }
    } catch (e) { deferred.resolve({ detail: { source: 'scialli-cambia', didError: true } }); }
    if (!ok && removed) {
      try { await fetch(ADD, { method: 'POST', headers: J, body: JSON.stringify({ items: [{ id: it.variant_id, quantity: 1, ...(props ? { properties: props } : {}) }] }) }); } catch (e) { /* noop */ }
    }
    this.busy = false;
    if (!ok) {
      this.show('Non disponibile, scegli un altro colore<span>Tocca per riprovare</span>', true);
      this.b.onclick = () => { this.b.className = 'sc-pop__busy'; this.b.onclick = null; };
      return;
    }
    this.close();
    if (location.pathname.startsWith('/cart')) { location.reload(); return; }
    if (!document.querySelector('theme-drawer[open], cart-drawer-component dialog[open]')) {
      const op = document.querySelector('[aria-controls="cart-drawer"]');
      if (op) op.click(); else location.href = '/cart';
    }
  }
}
const ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 13.5-5.8L20 8.5M20 4v4.5h-4.5M20 12a8 8 0 0 1-13.5 5.8L4 15.5M4 20v-4.5h4.5"/></svg>';
let busy = false, timer = null;
const enhance = async () => {
  if (busy) return;
  const rows = [...document.querySelectorAll('tr[data-key]')].filter((r) => !r.dataset.scDone && !r.querySelector('.sc-chg'));
  if (!rows.length) return;
  busy = true;
  try {
    const list = await getItems();
    rows.forEach((r) => { r.dataset.scDone = '1'; });
    list.forEach(({ it }) => {
      document.querySelectorAll(`tr[data-key="${it.key.replace(/"/g, '\\"')}"]`).forEach((row) => {
        if (row.querySelector('.sc-chg')) return;
        const wrap = row.querySelector('.cart-items__variants-wrapper');
        if (!wrap) return;
        const ul = document.createElement('ul');
        ul.className = 'list-unstyled'; ul.setAttribute('role', 'list');
        ul.innerHTML = `<li class="sc-chip"><button type="button" class="sc-chg">${ICON}Cambia colore</button></li>`;
        wrap.appendChild(ul);
      });
    });
  } finally { busy = false; }
};
const schedule = () => { if (timer) return; timer = setTimeout(() => { timer = null; enhance(); }, 150); };
if (!window.__scBound) {
  window.__scBound = true;
  ensureStyle();
  document.addEventListener('click', async (e) => {
    const b = e.target.closest?.('.sc-chg');
    if (!b) return;
    e.preventDefault();
    if (Pop.active) return;
    const key = b.closest('[data-key]')?.dataset.key;
    const list = await getItems();
    const t = list.find((x) => x.it.key === key);
    if (!t || Pop.active) return;
    Pop.active = new Pop(t);
  });
  const start = () => { schedule(); if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}